<template>
  <div class="page">
    <div
      class="slider-container"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <div class="slider-track" :style="trackStyle">
        <div v-for="(img, index) in images" :key="index" class="slide">
          <img :src="img" alt="slide image" />
        </div>
        <!-- <div class="weui-gallery">
      <span class="weui-gallery__img" :style="'background-image: url(' + url + ');'"></span>
    </div> -->
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.url = to.params.imgUrl;
      vm.images = to.params.imgUrlList;
      vm.currentIndex = to.params.index;
    });
  },
  data() {
    return {
      url: "",
      currentIndex: 0,
      startX: 0,
      endX: 0,
      images: [],
    };
  },
  computed: {
    trackStyle() {
      return {
        transform: `translateX(${-this.currentIndex * 100}%)`,
        transition: "transform 0.3s ease",
      };
    },
  },
  methods: {
    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
    },
    handleTouchEnd(e) {
      this.endX = e.changedTouches[0].clientX;
      this.handleSwipe();
    },
    handleSwipe() {
      const diffX = this.endX - this.startX;
      const swipeThreshold = 50; // 最小滑动距离阈值

      if (Math.abs(diffX) > swipeThreshold) {
        if (diffX > 0) {
          // 向右滑动
          this.prevSlide();
        } else {
          // 向左滑动
          this.nextSlide();
        }
      }
    },
    nextSlide() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
  },
};
</script>

<style>
/* .weui-gallery {
  background-color: inherit;
  display: block;
} */
.slider-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.slider-track {
  display: flex;
  height: 100%; /* 根据实际需要调整高度 */
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
